import { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { SUCCESS_MESSAGES } from '../constants';

interface CopyButtonProps {
  text: string;
  className?: string;
}

/**
 * CopyButton - Botão para copiar texto para a área de transferência
 */
export const CopyButton = ({ text, className = '' }: CopyButtonProps) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    } catch (error) {
      console.error('Failed to copy text:', error);
    }
  };

  return (
    <button
      onClick={handleCopy}
      className={`
        flex items-center gap-2
        text-[#F4CC04] text-sm
        border border-[#F4CC04]/30 rounded
        px-3 py-1.5
        bg-transparent
        hover:bg-[#F4CC04]/10 hover:border-[#F4CC04]
        transition-all duration-200
        cursor-pointer
        ${className}
      `}
      aria-label="Copiar mensagem"
    >
      {isCopied ? (
        <>
          <Check size={16} />
          <span className="font-medium">{SUCCESS_MESSAGES.fileCopied}</span>
        </>
      ) : (
        <>
          <Copy size={16} />
          <span className="font-medium">Copiar</span>
        </>
      )}
    </button>
  );
};
